<template>
  <div :id="id" :style="`height:${height};`"></div>
</template>

<script>
  import * as echarts from 'echarts'

  export default {
    name: 'Echart05',
    props: ['id', 'height', 'datas', 'color', 'reverse'],
    data() {
      return {
      }
    },
    watch: {
      datas: {
        deep: true,
        handler: function(newV, oldV) {
          if(!newV) return
          this.draw()
        }
      }
    },
    computed: {
      curColor() {
        let num = this.datas.Wcl
        let mb = this.datas.Mb
        if(this.reverse) {
          if(num >= 1 ) {
            return '#fc4318'
          } else if (0.6 <= num) {
            return '#deff00'
          } else {
            if(mb == 0) {
              return 'rgba(255, 255, 255, .1)'
            } else {
              return '#39eef1'
            }
          }
        } else {
          if(num >= 1 ) {
            return '#39eef1'
          } else if (0.6 <= num) {
            return '#deff00'
          } else {
            if(mb == 0) {
              return 'rgba(255, 255, 255, .1)'
            } else {
              return '#fc4318'
            }
          }
        }
      }
    },
    mounted() {
      if(Object.keys(this.datas).length !== 0) {
        this.draw()
      }
    },
    methods: {
      draw() {
        if (document.getElementById(this.id) == null) {
          return
        }
        echarts.dispose(document.getElementById(this.id))
        const myChart = echarts.init(document.getElementById(this.id))
        let option = {
          color: [this.curColor, 'rgba(255, 255, 255, .1)'],
          grid: {
            containLabel: true
          },
          calculahte: true,
          series: [
            {
              type: 'pie',
              radius: ['74%', '78%'],
              avoidLabelOverlap: false,
              label: {
              	show: false,
                position: 'center',
              },
              labelLine: {
                show: false
              },
              data: [{
              	value: this.datas.Sj,
              	name: '预算',
              	label: {
              		fontSize: 18,
              		color: '#fff',
              		show: true,
              		padding: [8,0,0,0],
              		formatter: [
                    '{name|'+ this.datas.name +'}',
                    '{wcl|'+ (this.datas.Wcl*100).toFixed(0) +'%}',
              			'{mb|本月目标: ' + (this.datas.Mb*1).toFixed(0) + '}',
              			'{sj|本月实际: ' + (this.datas.Sj*1).toFixed(0) + '}',
              			'{lj|年度累计: ' + (this.datas.Lj*1).toFixed(0) + '}',
              			'{tq|上年同期: ' + (this.datas.Tq*1).toFixed(0) + '}',
              		].join('\n'),
              		rich: {
              			name: {
              				color: 'rgba(255, 255, 255, .8)',
              				fontSize: 14,
              				fontWeight: 'bold',
              				lineHeight: 20
              			},
              			wcl: {
              				color: this.curColor,
                      fontSize: 18,
              				fontWeight: 'bold',
              				lineHeight: 28
              			},
              			mb: {
              				color: 'rgba(255, 255, 255, .6)',
                      fontSize: 12,
                      lineHeight: 18
              			},
              			sj: {
              				color: 'rgba(255, 255, 255, .6)',
                      fontSize: 12,
                      lineHeight: 18
              			},
              			lj: {
              				color: 'rgba(255, 255, 255, .6)',
                      fontSize: 12,
                      lineHeight: 18
              			},
              			tq: {
              				color: 'rgba(255, 255, 255, .6)',
                      fontSize: 12,
                      lineHeight: 18
              			}
              		},
              	},
              
              }, {
              	value: this.datas.Mb - this.datas.Sj,
              	name: '累计实际',
              	label: {
              		show:false
              	}
              }]
            }
          ]
        }
        myChart.setOption(option, true)
      }
    }
  }
</script>

<style>
</style>

